<template>
  <div id="HomePage">
    <!-- <div id="HomePage" v-if="isShow"> -->
    <div class="box">
      <Header :nav-list="navList" :active="2"/>
      <div class="content">
        <div class="item" @click="goPayDetail" style="margin-top: 50px;">
          <img
            src="https://moyi-uccn.oss-cn-beijing.aliyuncs.com/index_bg7.png"
            alt=""
            style="width: 100%;"
          />
        </div>
      </div>
      <!-- 底部-->
      <Footer />
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "home",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      active: 0, // 当前激活的导航索引
      navList: [
        {
          id: 0,
          title: "首页",
          url: "/home",
        },
        {
          id: 1,
          title: "产品展示中心",
          url: "/home",
        },
        {
          id: 2,
          title: "在线商城",
          url: "/online_store",
        },
        {
          id: 3,
          title: "增值服务（付费）",
          url: "/home",
        },
        {
          id: 4,
          title: "直播",
          url: "/live_detail",
        },
        {
          id: 5,
          title: "联系我们",
          url: "/home",
        },
        {
          id: 6,
          title: "登录",
          url: "/home",
        },
        {
          id: 7,
          title: "注册",
          url: "/home",
        },
      ],
    };
  },
  mounted() {
    /* wowjs动画 */
    var wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
    });
    wow.init();
  },
  methods: {
    navJump(item) {
      if (item.url) {
        this.$router.push(item.url);
      }
    },
    goPay() {
      this.$router.push("/pay");
    },
    goPayDetail() {
      this.$router.push("/pay_detail");
    },
  },
};
</script>
<style scoped lang="scss">
@import "../assets/css/header.scss";
::v-deep .box {
  /* 导航栏 */
  #header {
    position: absolute;
    top: 0px;
    background: #000;
    height: 80px;
    line-height: 80px;
    .header-nav-logo {
      margin-top: 20px;
    }
  }
}
</style>
